import styles from "./ContactCard.module.scss";
import WhatsAppIcon from "@Icons/WhatsAppIcon";
import EnvelopeIcon from "@Icons/EnvelopeIcon";
import PhoneIcon from "@Icons/PhoneIcon";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { PAGE } from "constants/configConstants";
import WechatGreenOutline from "@Icons/WechatGreenOutline";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import useIsApp from "hooks/useIsApp";
import { sendWebViewEvent } from "@Utils/webviewEvents";
import { WEB_VIEW_APP_EVENTS } from "@Utils/webApputils/analyticEvents";
import useCustomWindowOpen from "@Components/CustomWindowOpen";
import AmberCopilotLogo from "@Icons/AmberCopilotLogo";
import BoltIcon from "@Icons/BoltIcon";

const Icons: any = {
  liveChat: <AmberCopilotLogo height={22} width={22} />,
  whatsapp: <WhatsAppIcon height="22" width="22" fill="#25D366" />,
  email: <EnvelopeIcon height={22} width={22} fill="#E3A008" />,
  phone: <PhoneIcon height={22} width={22} fill="#3F83F8" />,
  weChat: <WechatGreenOutline height={22} width={22} />,
};

const Borders: any = {
  liveChat: styles.liveChatBorder,
  whatsapp: styles.whatsappBorder,
  email: styles.plainBorder,
  phone: styles.plainBorder,
};

const BgColors: any = {
  liveChat: styles.liveChatBgColor,
  whatsapp: styles.whatsappBgColor,
  weChat: styles.whatsappBgColor,
};

const TagTexts: any = {
  liveChat: "profile.support.components.supportlistitem.instantreply",
  whatsapp: "home.contactus.twominreply",
  weChat: "home.herosection.24hrsassistance",
};
type TriggerEventsArgs = {
  iconKey: string;
  href: string;
  isApp: boolean;
  handleZendeskCB?: () => void;
  customWindowOpen?: any;
};
const triggerEvents = ({
  iconKey,
  href,
  isApp,
  handleZendeskCB,
  customWindowOpen,
}: TriggerEventsArgs) => {
  if (iconKey == "liveChat" && handleZendeskCB) {
    handleZendeskCB();
  }
  gtagEventEmitter({
    action: "need_help_card_clicked",
    category: PAGE.HOME,
    iconKey,
  });
  if (href) {
    if (isApp) {
      sendWebViewEvent(WEB_VIEW_APP_EVENTS.OPEN_EXTERNAL_URL, { url: href });
    } else if (customWindowOpen) {
      customWindowOpen({ url: href, target: "_blank", isExternal: true });
    }
  }
};

const ContactCard = ({
  label,
  iconKey,
  showTag = false,
  href = "",
  dataTestId,
  handleZendeskCB,
}: any) => {
  const { t } = useTranslationHook();
  const isApp = useIsApp();
  const customWindowOpen = useCustomWindowOpen();
  return (
    <span
      role="none"
      className={styles.contactCardAnchor}
      onClick={() => triggerEvents({ iconKey, href, isApp, handleZendeskCB, customWindowOpen })}
    >
      <div
        className={formatClassNames(styles.contactCardInner, Borders[iconKey])}
        data-testid={dataTestId}
      >
        <button type="button" className={styles.symbolButton}>
          {Icons[iconKey]}
        </button>
        <div className={styles.contactCardLabel}>{t(label)}</div>
        {showTag && (
          <div className={formatClassNames(styles.quickReplyTag, BgColors[iconKey])}>
            {iconKey === "liveChat" ? <BoltIcon /> : <span className={styles.whiteDot} />}
            <span className={styles.quickReplyTagText}>{t(TagTexts[iconKey])}</span>
          </div>
        )}
      </div>
    </span>
  );
};

export default wrapperHOC(ContactCard, {
  componentName: "ContactCard-GetHelp-Home",
  showForChina: true,
});
